import httpClient from "@/services/base.service.js";

const apiBase = '/api/v1/applicationactivity/';

export default {
    create: function (params) {
        return httpClient.post(`${apiBase}create`, params);
    }
};
